module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "quick"
  }, [_vm._l((_vm.menu), function(item, i) {
    return [_c('a', {
      key: i,
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.onClick(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.icon
      }
    }), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.name))])])]
  })], 2), _vm._v(" "), (_vm.ad.open && _vm.ad.target !== 'miniprogram') ? _c('a', {
    staticClass: "ad",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onClickAd
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.ad.image
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8e19dd3c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/home/Quick.vue
// module id = 339
// module chunks = 0